import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import type { SocialPlatform } from "@content-os/config";

export interface PlatformRule { maxPerDay: number; minGapHours: number }
export interface PostingWindow { days: number[]; startHour: number; endHour: number }
export interface SchedulingConfig {
  timezone: string;
  platformRules: Record<SocialPlatform, PlatformRule>;
  defaultWindows: PostingWindow[];
  /** Extra formats every single-video post also goes out as (IG_STORY, FB_STORY, YOUTUBE_SHORT). */
  videoCompanionPostTypes?: string[];
}

export function useSchedulingConfig(brandId: string) {
  return useQuery({
    queryKey: ["scheduling-config", brandId],
    queryFn: () => apiFetch<SchedulingConfig>(`/brands/${brandId}/scheduling-config`),
    enabled: !!brandId,
  });
}

export function useUpdateSchedulingConfig(brandId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (config: SchedulingConfig) =>
      apiFetch<SchedulingConfig>(`/brands/${brandId}/scheduling-config`, {
        method: "PUT",
        body: JSON.stringify(config),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["scheduling-config", brandId] }),
  });
}
